export default "__VITE_ASSET__wdWloMqG__"